export default __webpack_public_path__ + "static/media/RoleIcon.ec4db6e9.svg";